// extracted by mini-css-extract-plugin
export default {"Card":"card_Card__iCFhZ","Card__text-wrapper":"card_Card__text-wrapper__aXAWD","Card__text":"card_Card__text__2g+9W"};